import React from 'react';

import { cn } from '@/utils/classname';

export interface PoeContentProps {
  content: string | string[] | React.ReactNode;
}

export const PoeContent = ({ content }: PoeContentProps) => {
  if (typeof content === 'string' || Array.isArray(content)) {
    return (
      <pre
        className={cn(
          'prose prose-sm text-chariot-text-primary max-w-none overflow-auto',
          'text-wrap focus:outline-hidden'
        )}
        tabIndex={-1}
      >
        {Array.isArray(content) ? content.join('\n') : String(content)}
      </pre>
    );
  }
  return (
    <div
      tabIndex={-1}
      className={cn(
        'text-chariot-text-primary max-w-none overflow-auto',
        'text-wrap focus:outline-hidden'
      )}
    >
      {content}
    </div>
  );
};
